@if (className) {
<icon type="star-fill" matTooltip="VIP assignment" [ngClass]="className"></icon>
}
